import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import { cargarDatosUsuario } from '@/util/LocalStorageLoaded';
import { useServices } from '@/context/ServicesProvider';
import { AxiosResponse } from 'axios';
import { Article, CategoriasStringServer, Format, GetArticlesResponse, GetArticulosPorFiltro, GetArticulosPropios, GetArticulosPropiosBusqueda, ModoBusqueda } from '@/objects/Articles';
import { numeroCajasPorDefecto, obtenerIdUltimoTotal, obtenerUltimoDateByArticles, obtenerUltimoIdByCategoria } from '@/util/Articulos';
import ListaArticulos from '@/components/elements/listas/lista_articulos/ListaArticulos';
import RowNoData from '@/components/elements/RowNoData';
import BarraBuscar from '../BarraBuscar';
import Boton from '@/components/elements/Boton';
import { Search } from '@mui/icons-material';
import { primary, white } from '@/constants/Colors';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import { mostrarAlerta } from '@/components/elements/Dialog';
import { esPremium } from '@/util/StringsUtil';
import { abrirAlertPremium } from '@/util/Comun';
import Exporter from './Exporter';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
}

export enum ModoMisLibros {
    MIS_LIBROS = "mis_libros",
    BUSCAR = "buscar"
}

function MisLibros() {

    const { articulosQueries } = useServices();

    const [articulos, setArticulos] = React.useState<Article[]>([]);
    const [textoBuscar, setTextoBuscar] = React.useState<string>("");
    const [modo, setModo] = React.useState<ModoMisLibros>(ModoMisLibros.MIS_LIBROS);

    const { t } = useTranslation();

    useEffect(() => {
        cargarAticulosPropios();
    }, []);

    function cargarAticulosPropios() {
        const datosUsuario = cargarDatosUsuario();

        let todosArticulos = articulos;

        const getArticulosConFiltro: GetArticulosPorFiltro = {
            id_user: Number(datosUsuario?.id_user),
            modo_busqueda: ModoBusqueda.RECIENTES,
            limit: numeroCajasPorDefecto(),
            last_id: Number(obtenerIdUltimoTotal(articulos)),
            last_date: obtenerUltimoDateByArticles(articulos)
        }

        articulosQueries?.getArticulosFiltro(getArticulosConFiltro).then((response: AxiosResponse<Article[]>) => {
            todosArticulos = todosArticulos.concat(response.data);
            setArticulos(todosArticulos);
        }
        ).catch((error: any) => {

        });
    }

    function buscarLibros(sinArticulosAnteriores: boolean = false) {
        const datosUsuario = cargarDatosUsuario();

        let todosArticulos = !sinArticulosAnteriores ? articulos : [];

        const getArticulosPorFiltro: GetArticulosPorFiltro = {
            modo_busqueda: ModoBusqueda.RECIENTES,
            texto_busqueda: textoBuscar,
            id_user: datosUsuario?.id_user,
            limit: numeroCajasPorDefecto(),
            last_id: Number(obtenerIdUltimoTotal(todosArticulos)),
            last_date: obtenerUltimoDateByArticles(todosArticulos)
        };

        articulosQueries?.getArticulosFiltro(getArticulosPorFiltro).then((response: AxiosResponse<Article[]>) => {
            todosArticulos = todosArticulos.concat(response.data);
            setArticulos(todosArticulos);
        }
        ).catch((error: any) => {

        });
    }

    function modoBuscarLibros() {
        setModo(ModoMisLibros.BUSCAR);
        buscarLibros(true);
    }

    function cargarMas() {
        if (modo == ModoMisLibros.MIS_LIBROS) {
            cargarAticulosPropios();
        } else {
            buscarLibros();
        }
    }

    function destacarTodos() {
        const datosUsuario = cargarDatosUsuario();
        //commprobar premium:
        if (esPremium(String(datosUsuario?.premium)) == false) {
            abrirAlertPremium(t);
            return;
        }
        articulosQueries?.destacarTodosLosLibros(String(datosUsuario?.id_user!)).then((response) => {
            //alert(JSON.stringify(response.data));
            if (response.status == 200) {
                if (response.data.resultado == 1) {
                    mostrarAlerta({
                        title: t('common:opciones.informacion'),
                        content: t('menu:secciones.mis_libros.se_han_destacado_todos_los_libros'),
                        showCancelButton: false,
                    });
                } else if (response.data.resultado == 0) {
                    mostrarAlerta({
                        title: t('common:opciones.informacion'),
                        content: t('menu:secciones.mis_libros.libros_ya_destacados'),
                        showCancelButton: false,
                    });
                }
            }
        }
        ).catch((error: any) => {

        });
    }

    const styleMargin: React.CSSProperties = {
        margin: "20px"
    }


    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloPrincipalH1 texto={t("menu:secciones.mis_libros.titulo")} />
            <section style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                <BarraBuscar textoBuscar={textoBuscar} setTextoBuscar={setTextoBuscar} />
                <div style={{ marginLeft: "10px", marginTop: "50px" }}>
                    <Boton startIcon={<Search />} texto={t("menu:secciones.mis_libros.buscar")} onClick={() => { modoBuscarLibros() }} />
                </div>
            </section>
            <section style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <Boton color={white} colorTexto={primary} startIcon={<AccessAlarmsIcon />} texto={t("menu:secciones.mis_libros.destacar_todos_los_libros")} onClick={() => { destacarTodos() }} />
                </div>

            </section>
            <section style={{ ...styleMargin, overflowY: 'hidden' }}>
                {articulos.length > 0 ?
                    <ListaArticulos articles={articulos} onClick={() => { cargarMas() }} t={t} /> :
                    <RowNoData texto={t("common:errores:no_tienes_libros_add_uno")} />
                }
            </section>
        </section>
    );
}

export default MisLibros;